/* eslint-disable */
"use strict";

import KTScrolltop from "./../../components/scrolltop.js";
import { KTUtil } from "./../../components/util.js";

var KTLayoutScrolltop = function() {
    var _element;
    var _object;

    var _init = function() {
        _object = new KTScrolltop(_element, {
          offset: 300,
          speed: 600,
        });
    }

	return {
		init: function(id) {
            _element = KTUtil.getById(id);

            if (!_element) {
                return;
            }

            _init();
		},

        getElement: function() {
            return _element;
        }
	};
}();

if (typeof module !== 'undefined') {
	// module.exports = KTLayoutScrolltop;
}

export default KTLayoutScrolltop;